// src/components/Navbar/Navbar.styles.js

// Import only the Material-UI components needed for styling purposes
import { styled } from '@mui/system';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';

// --- THEME COLORS ---
export const colors = {
    navbarBackground: 'rgba(17, 17, 17, 0.95)',
    drawerBackground: 'rgba(25, 25, 25, 0.98)',
    textColor: '#ffffff',
    accentColor: '#19abf0',
    iconColor: '#ffffff',
};









// --- FIX FOR 'scrolled' WARNING ---
export const StyledAppBar = styled(AppBar, {
    // This function tells styled-components which props to NOT forward to the DOM element.
    shouldForwardProp: (prop) => prop !== 'scrolled'
  })(({ scrolled }) => ({
      background: colors.navbarBackground,
      borderRadius: '0px',
      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
      opacity: scrolled ? 1 : 0,
      transform: scrolled ? 'translateY(0)' : 'translateY(-100%)',
      pointerEvents: scrolled ? 'auto' : 'none',
      transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
      zIndex: 1100,
  }));




// --- STYLED COMPONENTS ---
// export const StyledAppBar = styled(AppBar)(({ scrolled }) => ({
//     background: colors.navbarBackground,
//     borderRadius: '0px',
//     boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.5)',
//     opacity: scrolled ? 1 : 0,
//     transform: scrolled ? 'translateY(0)' : 'translateY(-100%)',
//     pointerEvents: scrolled ? 'auto' : 'none',
//     transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
//     zIndex: 1100,
// }));













export const NavbarContentBox = styled(Box)({
    padding: '0 20px',
    height: '4rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

export const StyledLogoContainer = styled('div')({
    padding: '0.5rem',
    margin: '0rem',
    backgroundColor: 'transparent',
    width: "auto", // Ensure this is flexible
    maxWidth:'300px',
    height: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

export const StyledMenuIconButton = styled(IconButton)({
    color: colors.iconColor,
    '&:hover': {
        color: colors.accentColor,
    },
});

export const StyledBox = (props) => (
    <Box
        sx={{
            background: colors.drawerBackground,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: '20px',
            boxSizing: 'border-box',
        }}
    >
        {props.children}
    </Box>
);

export const StyledCloseIcon = () => (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <CloseIcon
            sx={{
                width: '3rem',
                height: '3rem',
                color: colors.iconColor,
                '&:hover': {
                    color: colors.accentColor,
                },
            }}
        />
    </div>
);

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiPaper-root': {
        opacity: 0.95,
        backgroundColor: colors.drawerBackground,
        width: '250px',
    },
}));

export const StyledListItem = (props) => (
    <ListItem
        sx={{
            marginBottom: '0.5rem',
            justifyContent: 'center',
            padding: '5px 0',
        }}
    >
        {props.children}
    </ListItem>
);